import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-grid-spinner',
  styleUrl: './form-grid-spinner.component.scss',
  templateUrl: './form-grid-spinner.component.html',
  standalone: true,
  imports: [CommonModule],
})
export class FormGridSpinnerComponent {
  @Input()
  public isShown: boolean = true;
}
